import api from './api';

export const getTeams = async () => {
  try {
    const response = await api.get('/Team');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

export const getTeamById = async (id) => {
  try {
    const response = await api.get(`/Team/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

export const createTeam = async (team) => {
  try {
    const response = await api.post('/Team', team, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

export const updateTeam = async (id, team) => {
  try {
    const response = await api.put(`/Team/${id}`, team, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};

export const deleteTeam = async (id) => {
  try {
    const response = await api.delete(`/Team/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Server Error');
  }
};
